
import { Button } from "@/components/ui/button";
import { CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CreditCard } from "lucide-react";

export function BillingSection() {
  return (
    <>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <CreditCard className="h-5 w-5" />
          Billing
        </CardTitle>
      </CardHeader>
      <CardContent>
        <Button
          variant="outline"
          className="w-full"
          onClick={() => window.open("https://billing.stripe.com/p/login/test", "_blank")}
        >
          Manage Billing Information
        </Button>
      </CardContent>
    </>
  );
}
